import type React from 'react';

import { Button } from '@change/ds-core-ui';
import { CheckIcon, LinkIcon } from '@change/ds-icons';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import type { Props as MainProps } from '../../index';

import { useShareUrl } from './hooks/useShareUrl';

export const ShareUrl: React.FC<{ viewContext: MainProps['viewContext'] }> = ({ viewContext }) => {
	const { data, actions } = useShareUrl(viewContext);
	const { translate } = useI18n();

	return (
		<Button
			data-testid="copy-link-share-button"
			data-qa="copy-link-share-button"
			onClick={actions.handleShare}
			size="x-small"
			variant="secondary-solid"
			leadingIcon={
				data.copied ? (
					<CheckIcon
						data-testid="copy-link-icon-success"
						data-qa="copy-link-icon"
						aria-label={translate('corgi.petition.starter_dashboard_v2.recommendations.copy_link.aria_link_copied')}
						className="text-icon-success"
					/>
				) : (
					<LinkIcon
						data-testid="copy-link-icon"
						data-qa="copy-link-icon"
						aria-label={translate('corgi.petition.starter_dashboard_v2.recommendations.copy_link.aria_copy_link')}
						className="text-typography-strong"
					/>
				)
			}
			className="w-full md:w-auto"
		>
			<div className="flex flex-row items-center gap-1">
				{data.copied ? (
					<Translate value="corgi.petition.starter_dashboard.recommendations.copy_link.copy_success" />
				) : (
					<Translate value="corgi.petition.starter_dashboard.recommendations.copy_link.copy_button" />
				)}
			</div>
		</Button>
	);
};
